export const StarContext = {
	/**
	 * Represents the Promotion context
	 */
	Promotion: 1,
	/**
	 * Represents a Promotion Item context
	 */
	PromotionItem: 2,
	/**
	 * Represents a Newsletter List context
	 */
	NewsletterList: 3
};
